// =============================================================================
// GuestGuard - Wrapper that shows AccessDeniedDialog for guest users
// Use this to wrap any page/section that guests should not access
// =============================================================================

import React, { useState } from 'react';
import { useIsGuest } from '@/contexts/GuestContext';
import { AccessDeniedDialog } from '@/components/shared/AccessDeniedDialog';

interface GuestGuardProps {
  children: React.ReactNode;
}

/**
 * Wraps a page or section. If the current user is a guest,
 * the children are hidden and the AccessDeniedDialog is shown instead.
 */
export function GuestGuard({ children }: GuestGuardProps) {
  const isGuest = useIsGuest();
  const [dismissed, setDismissed] = useState(false);

  if (!isGuest) return <>{children}</>;

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <AccessDeniedDialog
        open={!dismissed}
        onOpenChange={(nextOpen) => {
          if (!nextOpen) setDismissed(true);
        }}
      />
      {dismissed && (
        <p className="text-muted-foreground text-sm">
          Vous n'avez pas accès à cette section.
        </p>
      )}
    </div>
  );
}
